import { Filter } from "lucide-react";
import ReusableDropdown from "../../../../components/ReusableDropdown";
import { ESCALATION_TYPES, STATUS_OPTIONS } from "../../constants/translations";
import { getTypeLabel, getStatusLabel } from "../../utils/helpers";

/**
 * Filters bar for My-Escalations tab.
 *
 * Props:
 *   selectedType    {string}   state
 *   setSelectedType {function}
 *   selectedStatus  {string}
 *   setSelectedStatus {function}
 *   sortOrder       {"asc"|"desc"}
 *   setSortOrder    {function}
 *   theme           {string}
 *   screenSize      {string}
 *   fonts           {object}
 *   styles          {object}
 *   language        {"en"|"ar"}
 *   t               {object}   text[language]
 */
const FiltersBar = ({
  selectedType,
  setSelectedType,
  selectedStatus,
  setSelectedStatus,
  sortOrder,
  setSortOrder,
  theme,
  screenSize,
  fonts,
  styles,
  language,
  t,
}) => {
  const selectStyle = styles.inlineSelect(theme === "dark", language, fonts, screenSize);

  const labelStyle = {
    display: "block",
    marginBottom: "0.5rem",
    fontSize: fonts.small,
    opacity: 0.8,
    color: theme === "dark" ? "rgba(248,250,252,0.9)" : "rgba(30,41,59,0.9)",
  };

  return (
    <div
      style={{
        ...styles.statCard,
        marginBottom: "1rem",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: screenSize === "xs" ? "column" : "row",
          gap: "1rem",
          flexWrap: "wrap",
        }}
      >
        {/* Type */}
        <div style={{ flex: 1, minWidth: "200px" }}>
          <label style={labelStyle}>
            <Filter
              size={14}
              style={{ marginRight: "0.5rem", verticalAlign: "middle" }}
            />
            {t.escalationType}
          </label>
          <ReusableDropdown
            items={[
              { id: "all", label: t.allTypes },
              ...ESCALATION_TYPES.map((type) => ({
                id: type,
                label: getTypeLabel(type, language),
              })),
            ]}
            value={selectedType}
            onChange={(val) => setSelectedType(val)}
            placeholder={t.escalationType}
            theme={theme}
            language={language}
            getItemKey={(item) => item.id}
            getItemLabel={(item) => item.label}
            showAllOnArrowClick
            showClear={selectedType !== "all"}
          />
        </div>

        {/* Status */}
        <div style={{ flex: 1, minWidth: "200px" }}>
          <label style={labelStyle}>{t.status}</label>
          <ReusableDropdown
            items={[
              { id: "all", label: t.allStatus },
              ...STATUS_OPTIONS.map((status) => ({
                id: status,
                label: getStatusLabel(status, language),
              })),
            ]}
            value={selectedStatus}
            onChange={(val) => setSelectedStatus(val)}
            placeholder={t.status}
            theme={theme}
            language={language}
            getItemKey={(item) => item.id}
            getItemLabel={(item) => item.label}
            showAllOnArrowClick
            showClear={selectedStatus !== "all"}
          />
        </div>

        {/* Sort */}
        <div style={{ flex: 1, minWidth: "200px" }}>
          <label style={labelStyle}>{t.sortByDate}</label>
          <ReusableDropdown
            items={[
              { id: "desc", label: t.newestFirst },
              { id: "asc", label: t.oldestFirst },
            ]}
            value={sortOrder}
            onChange={(val) => setSortOrder(val)}
            placeholder={t.sortByDate}
            theme={theme}
            language={language}
            getItemKey={(item) => item.id}
            getItemLabel={(item) => item.label}
            showAllOnArrowClick
            showClear={false}
          />
        </div>
      </div>
    </div>
  );
};

export default FiltersBar;